'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var isDefined = require('./is-defined');

var Identity = /*#__PURE__*/function () {
  function Identity(id, publicKey, idSignature, pubKeyIdSignature, type, provider) {
    _classCallCheck(this, Identity);

    if (!isDefined(id)) {
      throw new Error('Identity id is required');
    }

    if (!isDefined(publicKey)) {
      throw new Error('Invalid public key');
    }

    if (!isDefined(idSignature)) {
      throw new Error('Signature of the id (idSignature) is required');
    }

    if (!isDefined(pubKeyIdSignature)) {
      throw new Error('Signature of (publicKey + idSignature) is required');
    }

    if (!isDefined(type)) {
      throw new Error('Identity type is required');
    }

    if (!isDefined(provider)) {
      throw new Error('Identity provider is required');
    }

    this._id = id;
    this._publicKey = publicKey;
    this._signatures = Object.assign({}, {
      id: idSignature
    }, {
      publicKey: pubKeyIdSignature
    });
    this._type = type;
    this._provider = provider;
  }
  /**
  * This is only used as a fallback to the clock id when necessary
  * @return {string} public key hex encoded
  */


  _createClass(Identity, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this._publicKey;
    }
  }, {
    key: "signatures",
    get: function get() {
      return this._signatures;
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        publicKey: this.publicKey,
        signatures: this.signatures,
        type: this.type
      };
    }
  }], [{
    key: "isIdentity",
    value: function isIdentity(identity) {
      return identity.id !== undefined && identity.publicKey !== undefined && identity.signatures !== undefined && identity.signatures.id !== undefined && identity.signatures.publicKey !== undefined && identity.type !== undefined;
    }
  }, {
    key: "toJSON",
    value: function toJSON(identity) {
      return {
        id: identity.id,
        publicKey: identity.publicKey,
        signatures: identity.signatures,
        type: identity.type
      };
    }
  }]);

  return Identity;
}();

module.exports = Identity;